import "@babel/polyfill";
import { MDCDialog } from "@material/dialog";
const mdc = require("material-components-web");
const smartquotes = require("smartquotes");
import jump from "jump.js";
import enquire from "enquire.js/dist/enquire";
mdc.autoInit();

// replace those pesky dumbquotes
smartquotes();

/*
// if we want to replace em dashes...

emDash('h1')

function emDash(el) {
  let originalText = $(`${el}:contains('--')`).html()
  let newText = originalText.replace('--', '\u2014')
  $(el).html(newText)
}
*/

// auto init those modals!
$("[data-modal-id]").each(function() {
  const $this = $(this);

  if (!$this.hasClass("isDisabled")) {
    let targetId = $this.data("modal-id");
    let dialog = new MDCDialog(document.querySelector(`#${targetId}`));
    $this.click(() => dialog.open());
  }
});

// remove speakers to reorganize the layout
$(".speaker").each(function() {
  if (!$(this).is(":visible")) {
    $(this).remove();
  }
});

// hide show agenda sections
$(".agenda-day").each(function() {
  let $container = $(this);
  let $agenda = $("ul", this);
  let $grid = $(".hide-show-grid", this);

  if ($container.hasClass("open")) {
    $agenda.css("display", "block");
    $grid.css("display", "block");
  }

  $("h4", this).click(function() {
    $agenda.slideToggle(200);
    $grid.slideToggle(200);
    $container.toggleClass("open").toggleClass("closed");
  });
});

// add track titles to the two agenda section
$(".agenda-grid").each(function() {
  const title1 = $(".track-one.title", this).text();
  const title2 = $(".track-two.title", this).text();

  $(".track-one:not(.title)", this).prepend(`<h6>${title1}</h6>`);
  $(".track-two:not(.title)", this).prepend(`<h6>${title2}</h6>`);
});

//multitrack-city collapsible menu on mobile only
enquire.register("screen and (max-width:940px)", {
  match: function() {
    $(".city-region").each(function() {
      let $container = $(this);
      let $mtcity = $(".mt-city", this);

      if ($container.hasClass("open")) {
        $mtcity.css("display", "block");
      }

      $("h4", this).click(function() {
        $mtcity.slideToggle(200);
        $container.toggleClass("open").toggleClass("closed");
      });
    });
  },
  unmatch: function() {
    $(".city-region").each(function() {
      let $container = $(this);
      let $mtcity = $(".mt-city", this);

      $mtcity.css("display", "inline-block");

      $("h4", this).unbind("click");
    });
  }
});

$(window).on("load resize", function() {
  // set variables for all that we need
  var $body = $("body");
  var $header = $("#site-header");
  var $window = $(window);
  var $navigation = $("#site-nav");
  var $wrap = $("#wrap");
  var headerHeight = $header.outerHeight();

  // wait to set the fixed class and padding to avoid a weird jump
  $header.addClass("fixed");
  $body.css("padding-top", headerHeight);

  scrollChecker();

  $window.scroll(function() {
    scrollChecker();
  });

  function scrollChecker() {
    if ($navigation.css("display") !== "none") {
      if ($window.scrollTop() >= $wrap.offset().top - headerHeight) {
        $navigation.addClass("sticky");
        $wrap.addClass("padded");
      } else {
        $navigation.removeClass("sticky");
        $wrap.removeClass("padded");
      }
    } else {
      return null;
    }
  }
});

//Adjust the scroll position on load once the sticky nav has been updated
$(window).on("load", function() {
  const jumpSelector = window.location.hash;
  if (jumpSelector) {
    const jumpEl = document.querySelector(jumpSelector);
    if (jumpEl) {
      const navHeight =
        document.getElementById("site-header").getBoundingClientRect().height +
        document.getElementById("nav-wrap").getBoundingClientRect().height;
      const offset = -1 * (navHeight + 50);
      setTimeout(() => {
        jump(jumpEl, {
          duration: 0,
          offset
        });
      }, 0);
    }
  }
});

$("#mobile-nav a, #site-nav .mdc-button").on("click", function(e) {
  if ($(window).width() < 768) {
    $("#mobile-nav").slideUp("fast");
    $(".mobile-toggle").removeClass("arrow-up");
  }
});

$(".mobile-toggle").click(function(e) {
  e.preventDefault();
  $(this).toggleClass("arrow-up");
  // $('#mobile-nav li').removeClass('active')
  $("#mobile-nav").slideToggle("fast");
});

$('a[href^="#"], [data-href]').each(function() {
  let target, offset;
  const $window = $(window);
  let $this = $(this);

  if ($this.attr("data-href")) {
    if ($this.attr("data-href").startsWith("#")) {
      target = $this.attr("data-href");
    } else {
      target = "#" + $this.attr("data-href");
    }
  } else {
    target = $this.attr("href");
  }

  $this.on("click", function(e) {
    e.preventDefault();

    if ($(`#nav-wrap`).css("display") === "none") {
      $window.width() < 768 ? (offset = -70) : (offset = -100);
    } else {
      $window.width() < 768 ? (offset = -110) : (offset = -140);
    }

    jump(target, {
      duration: 500,
      offset
    });
  });
});

/////// FORMS

// TEXT INPUTS
function mdcTextInputizer(input) {
  // make sure we don't run this when it's already been run
  if (!$(input).hasClass("mdc-text-field__input")) {
    // stash important elements
    const $inputWrap = $(input).parent();
    const $label = $("label", $inputWrap).addClass("mdc-floating-label");
    // REMOVE ASTERSISKS
    $(".mktoAsterix", $inputWrap).remove();

    // delete the label so we can reposition
    $("label", $inputWrap).remove();

    // fix the date label above because date is a really inconsistent input
    if ($(input).hasClass("mktoDateField")) {
      $label.addClass("hovered-label"); // pairs with the stylesheet
    }

    // add mdc classes, attrs, append html
    $(input)
      .attr("placeholder", "") // clear the placeholders since our labels do that work
      .addClass("mdc-text-field__input"); // add the appropriate class for MDC

    $inputWrap
      .addClass("mdc-text-field working-now") // MDC classes
      .attr("data-mdc-auto-init", "MDCTextField") // auto init that MDC magic
      .append($label) // attach the label where it should go
      .append('<div class="mdc-line-ripple"></div>'); // line ripple? of course you want it
  }
}

// TEXTAREAS
function mdcTextAreaizer(input) {
  // See mdcTextInputizer() for details
  if (!$(input).hasClass("mdc-text-field__input")) {
    const $inputWrap = $(input).parent();
    const $label = $("label", $inputWrap).addClass("mdc-floating-label");

    $(".mktoAsterix", $inputWrap).remove();

    $("label", $inputWrap).remove();

    $(input)
      .attr("placeholder", "")
      .addClass("mdc-text-field__input");

    $inputWrap
      .addClass("mdc-text-field text-field mdc-text-field--textarea")
      .attr("data-mdc-auto-init", "MDCTextField")
      .append($label);
    // .append('<div class="mdc-line-ripple"></div>')
  }
}

// CHECKBOXES
function mdcCheckboxer(checkboxes) {
  // this gets complex but hold on. It'll make sense

  // store the labels in an array by order of appearance
  // start off my making sure we haven't already done this

  if ($(".mdc-form-field", checkboxes).length <= 0) {
    // now that we know this is the first time...
    let labels = []; // initialize empty variable for storing the labels
    const $wrap = $(checkboxes).parent(); // grap the input wrapper

    $(".mktoAsterix", $wrap).remove(); // remove the astersisk

    // marketo does dual labels. this is the big label for the group of checkboxes
    const bigLabel = {
      for: $("label", $wrap).attr("for"), // important for accessibilit and interactivity
      text: $("label", $wrap).html() // gets the text value of the label
    };

    // stash the labels
    $("label", checkboxes).each(function(index) {
      // since we're calling $(this) more than once, this saves us processing time by cacheing that lookup
      let $this = $(this);

      // creating an object of this specific label
      const assembledLabel = {
        order: index, // important for iterating
        for: $this.attr("for"), // see ${bigLabel}
        text: $this.html() // see ${bigLabel}
      };

      labels.push(assembledLabel); // append this object to the ${labels} array
      $this.remove(); // now that it's added, delete it from the DOM
    });

    // time to go through the checkboxes
    $("input", checkboxes).each(function(index) {
      // since we're calling $(this) more than once, this saves us processing time by cacheing that lookup
      let $this = $(this);

      $this
        .addClass("mdc-checkbox__native-control") // add MDC classes
        .wrap('<div class="mdc-form-field" />') // create a parent div
        .wrap('<div class="mdc-checkbox" />'); // nest another div above the input and below the parent div

      // create two vars based on the above work
      let $mdc_checkbox = $this.parent(); // <div class="mdc-checkbox"></div>
      let $mdc_form_field = $this.parent().parent(); // <div class="mdc-form-field"></div>

      // make mdc adjustments to the checkbox
      $mdc_checkbox
        .attr("data-mdc-auto-init", "MDCCheckbox") // lets MDC auto init on this
        .append(
          // we add a whole chunk of html here to animate those checkmarks.
          `
            <div class="mdc-checkbox__background">
              <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                <path class="mdc-checkbox__checkmark-path" fill="none"  d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
              </svg>
              <div class="mdc-checkbox__mixedmark"></div>
            </div>
          `
        );

      $mdc_form_field.attr("data-mdc-auto-init", "MDCFormField"); // auto init for the form-field to allow label clicking

      // Marketo labels behave differently if they have one or more than one, so here we account for that
      if (labels.length > 1) {
        // add all the mini labels if the checkboxes were plural
        $mdc_form_field.append(
          `<label class="onerem" for="${labels[index].for}">${labels[index].text}</label>`
        );
        $(checkboxes)
          .prev()
          .addClass("textified");
      } else {
        // if they're singular, add the bigLabel instead
        $("label", $wrap).remove();
        $mdc_form_field.append(
          `<label  for="${bigLabel.for}">${bigLabel.text}</label>`
        );
      }
    });
  }
}

// RADIO BUTTONS
function mdcCRadioButtonizer(radioButtons) {
  // Read the mdcCheckBoxer() notes to understand. This is nearly identical.
  if ($(".mdc-form-field", radioButtons).length <= 0) {
    const $fieldWrap = $(radioButtons).parent();
    $(".mktoAsterix", $fieldWrap).remove();
    let labels = [];
    const bigLabel = $(".mktoLabel", $fieldWrap).html();

    $(".mktoLabel", $fieldWrap).remove();

    $("label", radioButtons).each(function(index) {
      const assembledLabel = {
        order: index,
        for: $(this).attr("for"),
        text: $(this).html()
      };
      labels.push(assembledLabel);
      $(this).remove();
    });

    $("input", radioButtons).each(function(index) {
      let $this = $(this);

      $this
        .addClass("mdc-radio__native-control")
        .wrap('<div class="mdc-form-field" />')
        .wrap('<div class="mdc-radio" />');

      let $mdcRadio = $(this).parent();

      $mdcRadio.attr("data-mdc-auto-init", "MDCRadio").append(
        `
          <div class="mdc-radio__background">
            <div class="mdc-radio__outer-circle"></div>
            <div class="mdc-radio__inner-circle"></div>
          </div>
        `
      );

      $mdcRadio
        .parent()
        .attr("data-mdc-auto-init", "MDCFormField")
        .append(
          `<label for="${labels[index].for}">${labels[index].text}</label>`
        );
    });

    $fieldWrap.prepend(
      `<label class='mktoLabel textified'>${bigLabel}</label>`
    );
  }
}

// SELECT DROPDOWN
function mdcSelectivizer(dropdown) {
  if (!$(dropdown).hasClass("mdc-select__native-control")) {
    $(dropdown)
      .find('option[value=""]')
      .text("");

    // set our vars and delete the asterisk
    const fieldWrap = $(dropdown).parent();
    $(".mktoAsterix", fieldWrap).remove();
    const label = $("label", fieldWrap);

    $("label", fieldWrap).remove(); // remove the generated label for reconstruction

    // add that beatiful mdc class to the dropdown
    $(dropdown).addClass("mdc-select__native-control");

    // add that beatiful mdc class to the label as well
    $(label).addClass("mdc-floating-label");

    // tweak the wrapping div
    $(fieldWrap)
      .addClass("mdc-select") // mdc required class
      .prepend(`<i class="mdc-select__dropdown-icon"></i>`)
      .append(label) // add the label back in
      .append('<div class="mdc-line-ripple"></div>') // make it ripple with love
      .attr("data-mdc-auto-init", "MDCSelect"); // auto init magic
  }
}

// BUTTONS
function mdcButtonizer(button) {
  $(button).addClass("mdc-button mdc-button--unelevated"); // required mdc classes
  // .attr('data-mdc-auto-init', 'MDCRipple') // make that button ripple
}

// ERROR CHECKING!

// check and apply error classes to text inputs
function errorCheckerTextInputs(input) {
  let $this = $(input);

  $this.on("focus change keyup", function() {
    if ($this.hasClass("mktoInvalid")) {
      $(this)
        .parent()
        .addClass("invalid");
      $this
        .parent()
        .find("label")
        .addClass("mdc-floating-label--shake");
    } else {
      $(this)
        .parent()
        .removeClass("invalid");
    }
  });
}

// check and apply error classes to dropdowns
function errorCheckerSelect(input) {
  let $this = $(input);

  $this.focus(() => {
    if ($this.hasClass("mktoInvalid")) {
      if (!$this.val()) {
        $this.parent().addClass("invalid");
        // $this.parent().find('label').addClass('mdc-floating-label--shake')
      } else {
        $this.parent().removeClass("invalid");
      }
    }
  });

  $this.change(() => {
    if ($this.val() != "") {
      $this
        .parent()
        .find("label")
        .removeClass("mdc-floating-label--shake");
      $this
        .parent()
        .find(".mktoErrorMsg")
        .css("opacity", 0);
      $this.parent().removeClass("invalid");
    } else {
      $this.parent().addClass("invalid");
      $this
        .parent()
        .find("label")
        .addClass("mdc-floating-label--shake");
    }
  });
}

function initForm() {
  $(
    "#mktoForms2BaseStyle, #mktoForms2ThemeStyle, .mktoClear, .mktoOffset, .mktoGutter, .mktoForm style"
  ).remove();
  let $mktoTextFields = $(
    ".mktoTextField, .mktoEmailField, .mktoNumberField, .mktoTelField, .mktoUrlField, .mktoDateField"
  );
  let $mktoTextAreas = $("textarea.mktoField");
  let $mktoCheckboxes = $(".mktoCheckboxList");
  let $mktoRadioButtons = $(".mktoRadioList");
  let $mktoSelects = $(".mktoFieldWrap select");
  let $mktoButtons = $(".mktoButton");

  // work magic on the inputs
  $mktoTextFields.each(function() {
    mdcTextInputizer(this);
    errorCheckerTextInputs(this);
  });
  $mktoTextAreas.each(function() {
    mdcTextAreaizer(this);
    errorCheckerTextInputs(this);
  });
  $mktoCheckboxes.each(function() {
    mdcCheckboxer(this);
  });
  $mktoRadioButtons.each(function() {
    mdcCRadioButtonizer(this);
  });
  $mktoSelects.each(function() {
    mdcSelectivizer(this);
    errorCheckerSelect(this);
  });
  $mktoButtons.each(function() {
    mdcButtonizer(this);
  });

  // the easy way of firing material.
  mdc.autoInit();
}

// if we have a form, init that shit
if (typeof MktoForms2 !== "undefined") {
  MktoForms2.onFormRender(function(form) {
    initForm();
  });
}

// just do it... not sure if this is necessary
initForm();

import "./website-validation";
